<ef-process-detail [process]="process$ | async"></ef-process-detail>
<ef-logo-presenter
    [logo]="logo$ | async"
    [selectedError]="selectedErrorWithStatus$ | async"
    (ShowError)="onShowError($event)"
    (SaveLogo)="onSaveLogo($event)"
>
</ef-logo-presenter>
